export default __webpack_public_path__ + "static/media/recruiter-selected.1eaa28a6.svg";